import * as onboardingTypes from "../../types/admin/onboardingTypes";

export const taskCompletedReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case onboardingTypes.TASK_COMPLETED_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case onboardingTypes.TASK_COMPLETED_SUCCESS:
      return {
        ...state,
        loading: false,
        taskCompletedInfo: payload,
        error: "",
      };
    case onboardingTypes.TASK_COMPLETED_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        taskCompletedInfo: {},
      };
    default:
      return state;
  }
};

export const getAllOnboardingTasksReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case onboardingTypes.GET_ALL_ONBOARDING_TASKS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case onboardingTypes.GET_ALL_ONBOARDING_TASKS_SUCCESS:
      return {
        ...state,
        loading: false,
        onboardingTasksList: payload,
        error: "",
      };
    case onboardingTypes.GET_ALL_ONBOARDING_TASKS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        onboardingTasksList: {},
      };
    default:
      return state;
  }
};
// supportCardReducer.js

const initialState = {
  isSupportCardVisible: false,
};

// export const supportCardReducer = (state = initialState, action) => {
//   const { type, payload } = action;
//   switch (type) {
//     case onboardingTypes.TOGGLE_SUPPORT_CARD:
//       return {
//         ...state,
//         isSupportCardVisible: payload,
//       };
//     default:
//       return state;
//   }
// };
export const supportCardReducer = (state = initialState, action) => {
  switch (action.type) {
    case onboardingTypes.TOGGLE_SUPPORT_CARD:
      return {
        ...state,
        isSupportCardVisible: action.payload,
      };
    default:
      return state;
  }
};
